var exports = {
  "kL": "xa15a2ab7--87fe51--container",
  "Kk": "xa15a2ab7--87fe51--icon",
  "y_": "xa15a2ab7--87fe51--remoteness",
};

module.exports = exports;
